module.exports = __webpack_public_path__ + "static/media/service_application_qrcode.eba72013.png";